import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableAppLinks from './tableAppLinks';

export default {
  title: 'About section',
  attributeName: 'infoPagesWlp',
  helpText: '',
  fields: [
    {
      attributeName: 'aboutSection',
      type: FormInputTypes.TEXT_EDITOR,
      label: 'About section',
      toolbar:['heading', 'alignment', 'bold', 'italic', 'link'],
      placeholder: 'Video description...',
      helpText: 'Description of the video.',
    },
     {
      attributeName: 'aboutSectionImage',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'About section image (926x328 px)',
      helpText: 'Add an image for the about section.',     
      hasSelect:false,
      fileType: ['.jpg', '.jpeg', '.png'],
      allowedSizes: [
        { width: 926, height: 328 },
      ],
    },
  ],
};
